import React, { useContext, useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslations, useLocale } from 'next-intl';

import Headline from '@components/atoms/headline/headline';
import Copy from '@components/atoms/copy/copy';
// import Span from '@components/atoms/span/span';

import StyledActionBar from './actionBar.style';

import { WishesContext } from '../../contexts/wishesProvider';

const ActionBar = ({ children }) => {
  const t = useTranslations();
  const locale = useLocale();
  const { showIntroduction, totalWishes } = useContext(WishesContext);
  const actionBar = useRef(null);
  const [actionBarWidth, setActionBarWidth] = useState(0);

  useEffect(() => {
    if (!actionBar.current) return;
    setActionBarWidth(actionBar.current.clientWidth);
  }, [showIntroduction]);

  if (showIntroduction) return null;

  return (
    <StyledActionBar>
      <div className="actionBar__wishes-count">
        <Copy
          focused
          noMargin
          dangerouslySetInnerHTML={{
            __html: t('wishes.totalWishes', { count: `<span style="font-weight: 700">750</span>` })
          }}
        />
        <Headline secondary>
          {totalWishes.toString().replace(/\B(?=(\d{3})+(?!\d))/g, locale === 'de' ? '.' : ',')}
          <Copy focused noMargin tag="span" style={{ textTransform: 'none' }}>
            {` ${t('wishes.visible')}`}
          </Copy>
        </Headline>
      </div>
      <div
        ref={actionBar}
        className="actionBar__actions"
        style={{ '--actionsWidth': `${actionBarWidth}px` }}
      >
        {children}
        <div className="actionBar__animation-toggle" />
      </div>
    </StyledActionBar>
  );
};

ActionBar.propTypes = {
  children: PropTypes.node.isRequired
};

export default ActionBar;
